
import { fromJS } from 'immutable';
import { Reducer } from 'redux';
import { actions } from '../constants/landing';

export const initialState: unknown = fromJS({});

const reducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_CONTENT:
      state = state.set('content', fromJS(action.content));

      return state;
    default: {
      return state;
    }
  }
};

export { reducer as landingReducer };
